<template>
  <div class="RP-Master">
    <div class="report-head">
      <div class="report-head-info">
        <img :src="Global.companyLogo" alt="" />
        <div class="head-info-name">{{ Global.systemNM == '' ? '心理防护系统' : Global.systemNM }}</div>
      </div>
      <div class="report-head-menu">
        <ul class="report-head-menu-ul">
          <li @click="goHome">
            <img src="../../assets/img/ReportData/reportdata-relogin.png" alt="" />
            <span>回到主页</span>
          </li>
          <li @click="reLogin">
            <img src="../../assets/img/ReportData/reportdata-relogin.png" alt="" />
            <span>重新登录</span>
          </li>

          <li @click="modify">
            <img src="../../assets/img/ReportData/reportdata-relogin.png" alt="" />
            <span>修改密码</span>
          </li>
        </ul>
        <div class="my-user">{{ Global.realName }}</div>
      </div>
    </div>
    <div class="report-main">
      <router-view />
    </div>
    <el-dialog  title="提示" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
    <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm" :rules="rules"
      style="width: 50%; margin: auto;">
      <el-form-item :label="$t('original.languages245')" prop="lpass">
        <el-input type="password" v-model="ruleForm.lpass" :placeholder="$t('original.languages4')" maxlength="20"></el-input>
      </el-form-item>
      <el-form-item :label="$t('original.languages246')" prop="newpass">
        <el-input type="password" v-model="ruleForm.newpass" :placeholder="$t('original.languages4')" maxlength="20">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('original.languages247')" prop="newpass2">
        <el-input type="password" v-model="ruleForm.newpass2" :placeholder="$t('original.languages4')"
          maxlength="20"></el-input>
      </el-form-item>
    </el-form>
    <el-button @click="tj('ruleForm')" style="margin-left: 49%;" type="primary">
        {{ $t('original.save') }}
    </el-button>
  </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      ruleForm: {
        lpass: '',
        newpass: '',
        newpass2: '',
      },
      rules: {
        lpass: [
          {
            required: true,

            message: '请输入原始密码!',
            trigger: 'blur',
          },
        ],
        newpass: [
          {
            required: true,
            pattern: /(?!\d+$)(?!^[a-zA-Z]+$)(?!^[_#@]+$).{8,20}/,
            message: '8至20位，包含数字、英文字母',
            trigger: 'blur',
          },
        ],
        newpass2: [
          {
            required: true,
            pattern: /(?!\d+$)(?!^[a-zA-Z]+$)(?!^[_#@]+$).{8,20}/,
            message: '8至20位，包含数字、英文字母',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  created() { },
  methods: {
    reLogin: function () {
      this.$router.push('/login')
    },
    modify() {
      this.dialogVisible = true
    },
    goHome: function () {
      this.$router.push('/ReportData/RPHome')
    },
    tj(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$Http_Post('User/GetChangePassword', {
            FistPwd: this.ruleForm.newpass,
            LastPwd: this.ruleForm.newpass2,
            Pwd: this.ruleForm.lpass,
          }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.Global.request_successful(res.Message)
              sessionStorage.removeItem('username')
              this.$router.push('/login')
            } else {
              this.Global.request_failure(res.Message)
            }
          })
        } else {
          this.Global.request_failure('信息填写有误!')
          return false
        }
      })
    },
  },
  mounted() { },
}
</script>
<style>
/* thead th {
  background-color: rgb(73, 80, 90) !important;
}
.el-button--primary {
  background-color: rgb(73, 80, 90) !important;
  border-color: rgb(114, 117, 121);
} */
.rp-table_btn {
  padding: 5px 10px;
  color: rgba(36, 153, 255, 1);
  cursor: pointer;
  font-weight: bold;
  text-decoration: underline;
}

.el-container {
  padding: 10px;
  height: 100%;
}

.RP-Master {
  margin: 0 0;
  padding: 0 0;
  height: 100%;
}

.report-head {
  height: 70px;
  width: 100%;
  background-image: url('../../assets/img/ReportData/RPMain-BG-Header.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.report-main {
  width: 100%;
  height: calc(100% - 70px);
}

.report-head-info {
  float: left;
  width: 50%;
  height: 70px;
  line-height: 70px;
  margin-left: 2%;
}

.report-head-info img {
  width: 50px;
  height: 50px;
  margin-top: 10px;
  float: left;
}

.report-head-info .head-info-name {
  float: left;
  margin-left: 20px;
  font-size: 35px;
  font-weight: bold;
  color: white;
  letter-spacing: 3px;
  font-family: '华文隶书';
}

.report-head-menu {
  float: right;
  margin-top: 5px;
  margin-right: 2%;
  text-align: right;
}

.report-head-menu-ul {
  float: right;
  margin-top: 5px;
  color: white;
  cursor: pointer;
  height: 30px;
  font-weight: bold;

}

.report-head-menu .my-user {
  color: rgb(197, 98, 5);
  font-size: 12px;
}

.report-head-menu-ul li {
  float: left;
  margin-left: 10px;
}

.report-head-menu-ul li span {
  text-decoration: underline;
}

.report-head-menu-ul img {
  width: 20px;
  height: 20px;
  vertical-align: middle;
  margin-right: 3px;
}

.ReportDataMater-gray {
  border: 1px solid #e7e7e7;
  height: calc(100% - 2px) !important;
  overflow: auto;
  background-color: rgb(235, 236, 237);
}

.ReportDataMater-white {
  background-color: white;
}

.RDMater-gray-header {
  background: white;
  overflow: hidden;
  height: auto !important;
}

.RDMaster-Query-Option {
  float: right;
}

.RDMater-gray-main {
  margin-top: 10px;
  background: rgba(255, 255, 255, 1);
}

.must-tip {
  vertical-align: middle;
  color: red;
}

/*弹框样式定义  -------开始*/
.dialog-second-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

.dialog-content {
  overflow: auto;
  border: 1px solid #cec3c0;
  padding: 10px;
  box-shadow: 0px 0px 5px #d9d1d0;
  height: calc(100% - 64px);
}

.dialog-content table {
  width: 100%;
  border-collapse: collapse;
  border: none;
}

.dialog-content tr {
  height: 50px;
}

.dialog-content table td {
  border: solid #e2e3e4 1px;
  padding-left: 10px;
}

.dialog-title {
  width: 25%;
  text-align: right;
  padding-right: 20px;
}

.dialog-cnt {
  padding-left: 20px;
}

.dialog-content input[type='text'] {
  width: 90%;
}

.dialog-content .el-select,
.dialog-content .el-date-editor {
  width: 90%;
}

.dialog-content .el-select input[type='text'],
.dialog-content .el-date-editor input[type='text'] {
  width: 100%;
}

.dialog-option {
  margin-top: 15px;
  text-align: center;
}

.dialog-cascader {
  width: 100%;
}

.dialog-tip {
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
}

/*弹框样式定义  -------结束*/

/* .el-button--primary:focus,
.el-button--primary:hover {
  border: 1px solid rgb(73, 80, 90);
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #777a71;
  border-color: #777a71;
} */

.sw-load {
  width: 260px;
  height: 80px;
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
}

.sw-load-tip {
  height: 50px;
  line-height: 50px;
  color: rgb(78, 78, 78);
}

.item-time {
  font-size: 14px;
}

.item-creator {
  font-size: 14px;
  float: right;
  margin-right: 10px;
}

.export-bar {
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
  font-size: 18px;
}

.export-bar-left {
  float: left;
  width: 50%;
  text-align: center;
  color: rgb(8, 95, 226);
  text-decoration: underline;
}

.export-bar-right {
  float: right;
  width: 50%;
  text-align: center;
  color: rgb(8, 95, 226);
  text-decoration: underline;
}

.export-bar-left:hover,
.export-bar-right:hover {
  cursor: pointer;
}

.el-cascader {
  width: 90%;
}

.el-cascader .el-input .el-input__inner {
  width: 100%;
}

.el-pagination {
  text-align: right;
}
</style>
